module.exports = __webpack_public_path__ + "static/media/banner_HEM.7dc47c91.jpg";